export const useVideoSection = () => {
  const { analyticEvent, fbPixelEvent } = useAnalytic()

  const eventHomeVideo = (videoName: string) => {
    analyticEvent({
      ga4ActionName: 'play_video_home',
      ga4Label: videoName,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Video - Play',
      fbValue: { label: videoName },
    })
  }

  return {
    eventHomeVideo,
  }
}
